module.exports = __webpack_public_path__ + "media/images/dashboard/light/tile_icon_ringpool_allocations-fff5432f17f5d113f7a933e738a5ffb2.png";